/**
 * Efast ERP - 数据看板逻辑 (V2.0)
 * 稳健渲染版：解决异步加载时序问题
 */

const Dashboard = {
    // 适配真实字段的 Mock 数据
    mockData: {
        inquiries: [
            { id: '20260623001', buyerName: 'malik malik', country: 'PK', product: 'Magsafe Case (ZF-01)', channel: 'Inquiry', time: '06-23 04:58', summary: 'Asking for tracking info', l_level: 'L3', type: '成交客户', owner: 'Jason Wu', roadblock: '无', status: '待跟进', next_action: '发送物流单号截图', priority: 'P0' },
            { id: '20260623002', buyerName: 'Alan Kraiem', country: 'US', product: 'Phone Holder (K-09)', channel: 'RFQ', time: '06-23 00:57', summary: 'Discussing customization details', l_level: 'L1', type: '流失预警', owner: 'Jeffrey Lu', roadblock: '运费昂贵', status: '议价中', next_action: '推荐专线物流方案', priority: 'P0' },
            { id: '20260623003', buyerName: 'MEMODI', country: 'US', product: '3-in-1 Charger', channel: 'Direct', time: '06-23 03:23', summary: 'Asking for sample stock', l_level: 'L2', type: '强开预警', owner: 'Samson Qiu', roadblock: '库存确认中', status: '待报价', next_action: '确认周五补货时间', priority: 'P1' }
        ],
        quality: {
            coreMetrics: [],
            coreSummary: '',
            rankings: [],
            rankingDetail: '',
            tierLoss: [],
            potentialCustomers: [],
            roadmap: []
        },
        sales: {
            agents: [
                { name: 'Samson', detail: '12单 / $4,500', total: '$4,500', ship: '1.2天' },
                { name: 'Jeffrey', detail: '8单 / $3,200', total: '$3,200', ship: '1.9天' }
            ],
            profiles: { newRatio: '35%', oldRatio: '65%', l3l4Ratio: '45%' },
            hotProducts: ['Magsafe Case', 'ZF-01 Holder', 'K-09 Stand'],
            health: '交易表现：优 | 纠纷率：0.5% (低于行业平均)'
        }
    },

    // 当前管理员视角下临时切换的业务员（null 表示看全部）
    _viewAs: null,

    init: function() {
        console.log('[Dashboard] Initializing with Professional Strategic Logic...');
        const self = this;
        let retry = 0;

        const checkExist = setInterval(() => {
            if (document.getElementById('dashboard-inquiry-list')) {
                clearInterval(checkExist);
                self.loadData();
            } else if (retry > 20) {
                console.error('[Dashboard] Template loading timed out');
                clearInterval(checkExist);
            }
            retry++;
        }, 300);
    },

    // 抽出来方便切换视角时复用
    loadData: function() {
        const self = this;
        const token = typeof Auth !== 'undefined' ? Auth.getToken() : sessionStorage.getItem('efast_token');
        const asParam = self._viewAs ? ('?asAlias=' + encodeURIComponent(self._viewAs)) : '';
        fetch('/api/dashboard' + asParam, {
            headers: { 'Authorization': 'Bearer ' + (token || '') }
        })
        .then(r => r.json())
        .then(data => {
            if (data && data.inquiries) {
                console.log('[Dashboard] Live data:', data.inquiries.length, 'inquiries; scope:', data._viewScope);
                self.mockData = data;
            } else {
                console.warn('[Dashboard] Server returned empty data, fallback to mockData');
            }
            self.renderData();
            self.renderScopeBar(data && data._viewScope, data && data._availableOwners);
        })
        .catch(err => {
            console.error('[Dashboard] Fetch failed, fallback to mockData:', err);
            self.renderData();
        });
    },

    // 渲染顶部视角徽章 + 业务员筛选下拉
    renderScopeBar: function(scope, owners) {
        const info = document.getElementById('inquiry-scope-info');
        const filterBox = document.getElementById('inquiry-scope-filter');
        const select = document.getElementById('inquiry-owner-select');
        if (!info || !scope) return;

        const isAdmin = scope.role === 'boss' || scope.role === 'supervisor';
        if (scope.mode === 'all') {
            info.innerHTML = `<i class="fa-solid fa-eye"></i> 当前视角：<b style="color:#1f3864">管理员全员视图</b> · 操作人：${scope.viewer || ''} (${scope.role})`;
        } else if (scope.mode === 'admin-as') {
            info.innerHTML = `<i class="fa-solid fa-user-secret"></i> 当前视角：<b style="color:#9d174d">代看 ${scope.alias}</b>（共 ${scope.totalMine}/${scope.totalAll} 条）· 操作人：${scope.viewer}`;
        } else {
            const warn = scope.warning ? `<span style="color:#dc2626; margin-left:8px;">⚠️ ${scope.warning}</span>` : '';
            info.innerHTML = `<i class="fa-solid fa-user-tag"></i> 当前视角：<b style="color:#059669">${scope.alias || '(未绑定)'}</b> · 操作人：${scope.viewer}（${scope.totalMine || 0} 条专属询盘）${warn}`;
        }

        if (isAdmin && filterBox && select && Array.isArray(owners)) {
            filterBox.style.display = 'block';
            // 仅首次填充选项，避免切换时重建丢焦
            if (select.options.length <= 1) {
                owners.forEach(o => {
                    const opt = document.createElement('option');
                    opt.value = o;
                    opt.textContent = o;
                    select.appendChild(opt);
                });
            }
            select.value = this._viewAs || '';
        } else if (filterBox) {
            filterBox.style.display = 'none';
        }
    },

    // 管理员切换业务员视角
    switchOwnerView: function(alias) {
        this._viewAs = (alias && alias.trim()) ? alias.trim() : null;
        console.log('[Dashboard] Admin switching view to:', this._viewAs || '(全部)');
        this.loadData();
    },

    // 点击"已回访"按钮：变黑色 + 禁用 + 写入 localStorage
    markVisited: function(btn) {
        if (!btn || btn.disabled) return;
        const key = btn.getAttribute('data-key');
        if (!key) return;

        // 更新按钮样式
        btn.disabled = true;
        btn.style.background = '#1f2937';
        btn.style.color = '#fff';
        btn.style.cursor = 'not-allowed';
        btn.style.border = '1px solid #1f2937';
        btn.innerText = '已回访 ✓';

        // 持久化（按 key 存）
        try {
            const visited = JSON.parse(localStorage.getItem('efast_visited_inquiries') || '{}');
            visited[key] = { time: new Date().toISOString() };
            localStorage.setItem('efast_visited_inquiries', JSON.stringify(visited));
        } catch (e) {
            console.error('[Dashboard] markVisited save failed:', e);
        }
    },

    switchTab: function(tabId) {
        document.querySelectorAll('.inv-tab-btn').forEach(btn => {
            btn.classList.toggle('active', btn.getAttribute('data-tab') === tabId);
        });
        document.querySelectorAll('.inv-tab-content').forEach(content => {
            content.style.display = (content.id === tabId) ? 'block' : 'none';
        });
    },

    renderData: function() {
        // Tab 1: 询盘数据
        const inqList = document.getElementById('dashboard-inquiry-list');
        if (inqList) {
            // 读取已回访记录（localStorage 持久化）
            let visited = {};
            try { visited = JSON.parse(localStorage.getItem('efast_visited_inquiries') || '{}'); } catch (e) { visited = {}; }

            inqList.innerHTML = this.mockData.inquiries.map((inq, idx) => {
                const visitKey = `${inq.id || ''}__${inq.buyerName || ''}`.replace(/\s+/g, '_');
                const isVisited = !!visited[visitKey];
                const btnStyle = isVisited
                    ? 'background:#1f2937; color:#fff; cursor:not-allowed; border:1px solid #1f2937;'
                    : 'background:#10b981; color:#fff; cursor:pointer; border:1px solid #059669;';
                const btnText = isVisited ? '已回访 ✓' : '已回访';
                const btnDisabled = isVisited ? 'disabled' : '';
                // 优先级徽章配色
                const prio = (inq.priority || 'P3').toUpperCase();
                const prioColor = prio === 'P0' ? 'background:#dc2626;color:#fff'
                                : prio === 'P1' ? 'background:#f59e0b;color:#fff'
                                : prio === 'P2' ? 'background:#3b82f6;color:#fff'
                                : 'background:#94a3b8;color:#fff';
                return `
                <tr class="row-${prio.toLowerCase()}" data-visit-key="${visitKey}">
                    <td style="text-align:center;"><span style="display:inline-block;${prioColor};padding:4px 10px;border-radius:4px;font-size:12px;font-weight:700;">${prio}</span></td>
                    <td><b>${inq.buyerName || ''}</b><br><small>${inq.country || ''}</small></td>
                    <td><div style="font-size:11px;">${inq.product || ''}</div><div style="font-size:10px; color:#999;">${inq.channel || ''} | ${inq.time || ''}</div></td>
                    <td><div class="ai-summary-box">${inq.summary || ''}</div></td>
                    <td><span class="badge">${inq.l_level || ''}</span><br><small style="color:#666">${inq.type || ''}</small></td>
                    <td><b>${inq.owner || ''}</b><br><small style="color:#dc2626">${inq.roadblock || ''}</small></td>
                    <td><span style="font-weight:700">${inq.status || ''}</span><br><small style="color:#059669">建议: ${inq.next_action || ''}</small></td>
                    <td style="text-align:center;">
                        <button class="btn-visit"
                            data-key="${visitKey}"
                            ${btnDisabled}
                            onclick="Dashboard.markVisited(this)"
                            style="${btnStyle} padding:6px 12px; border-radius:4px; font-size:12px; font-weight:600; transition:all 0.2s;">
                            ${btnText}
                        </button>
                    </td>
                </tr>
            `;
            }).join('');
        }

        // Tab 2: 接待质量 (按周报模板格式 - 5 个板块)
        const q = this.mockData.quality || {};

        // 板块 1: 核心指标
        const coreBody = document.getElementById('quality-core-metrics');
        if (coreBody && q.coreMetrics) {
            coreBody.innerHTML = q.coreMetrics.map(m => {
                const stateColor = m.state && m.state.indexOf('❌') >= 0 ? '#dc2626'
                    : m.state && m.state.indexOf('✅') >= 0 ? '#059669' : '#6b7280';
                return `<tr style="border-bottom:1px solid #f1f5f9;">
                    <td style="padding:10px;"><b>${m.name}</b></td>
                    <td style="padding:10px; color:#1e40af; font-weight:700;">${m.value}</td>
                    <td style="padding:10px; color:#6b7280;">${m.industry}</td>
                    <td style="padding:10px; color:${stateColor};">${m.state}</td>
                </tr>`;
            }).join('');
        }
        const coreSummary = document.getElementById('quality-core-summary');
        if (coreSummary) coreSummary.innerHTML = q.coreSummary ? '<b>📊 诊断结论：</b>' + q.coreSummary : '';

        // 板块 2: 业务员绩效
        const rankingBody = document.getElementById('agent-quality-body');
        if (rankingBody && q.rankings) {
            rankingBody.innerHTML = q.rankings.map(r => {
                const statusColor = r.status && (r.status.indexOf('⭐') >= 0 || r.status.indexOf('标杆') >= 0) ? '#059669'
                    : r.status && (r.status.indexOf('流失') >= 0 || r.status.indexOf('延迟') >= 0 || r.status.indexOf('严重') >= 0) ? '#dc2626'
                    : '#6b7280';
                return `<tr style="border-bottom:1px solid #f1f5f9;">
                    <td style="padding:10px;"><b>${r.name}</b></td>
                    <td style="padding:10px;">${r.traffic}</td>
                    <td style="padding:10px; color:#1e40af; font-weight:700;">${r.fiveMin}</td>
                    <td style="padding:10px;">${r.avgTime}</td>
                    <td style="padding:10px; color:${statusColor}; font-weight:600;">${r.status}</td>
                </tr>`;
            }).join('');
        }
        const agentDetail = document.getElementById('agent-quality-detail');
        if (agentDetail) agentDetail.innerHTML = q.rankingDetail ? '<b>📋 质量分析详情：</b>' + q.rankingDetail : '';

        // 板块 3: 客户分层流失诊断
        const tierBox = document.getElementById('tier-loss-analysis');
        if (tierBox && q.tierLoss) {
            tierBox.innerHTML = q.tierLoss.map(t => {
                const tierColor = t.tier.indexOf('L4') >= 0 || t.tier.indexOf('L3') >= 0 ? '#9d174d'
                    : t.tier.indexOf('L2') >= 0 ? '#0369a1' : '#6b7280';
                return `<div style="padding:12px; background:#fafafa; border-left:4px solid ${tierColor}; border-radius:4px;">
                    <div style="font-weight:700; color:${tierColor}; margin-bottom:6px;">${t.tier}</div>
                    <div style="font-size:12px; color:#374151; line-height:1.6;"><b>痛点：</b>${t.painPoint}</div>
                    <div style="font-size:12px; color:#4b5563; line-height:1.6; margin-top:4px;"><b>原因：</b>${t.reason}</div>
                </div>`;
            }).join('');
        }

        // 板块 4: 潜力客户跟进
        const potentialBody = document.getElementById('potential-customers-body');
        if (potentialBody && q.potentialCustomers) {
            potentialBody.innerHTML = q.potentialCustomers.map(c => `
                <tr style="border-bottom:1px solid #f1f5f9;">
                    <td style="padding:10px;"><b>${c.name}</b></td>
                    <td style="padding:10px; color:#1e40af;">${c.tierRegion}</td>
                    <td style="padding:10px;">${c.demand}</td>
                    <td style="padding:10px; color:#059669;">${c.action}</td>
                </tr>
            `).join('');
        }

        // 板块 5: 改进路线图
        const roadmap = document.getElementById('improvement-roadmap');
        if (roadmap && q.roadmap) {
            roadmap.innerHTML = q.roadmap.map(item => `
                <li style="margin-bottom:10px;"><b>${item.title}</b>：${item.detail}</li>
            `).join('');
        }

        // Tab 3: 成交分析
        const salesList = document.getElementById('dashboard-sales-list');
        if (salesList) {
            salesList.innerHTML = this.mockData.sales.agents.map(a => `
                <tr>
                    <td><b>${a.name}</b></td>
                    <td>${a.detail}</td>
                    <td style="color:#1e40af; font-weight:700;">${a.total}</td>
                    <td><span style="color:#10b981">${a.ship}</span></td>
                </tr>
            `).join('');
        }
        document.getElementById('customer-profile-stats').innerHTML = `
            <div>新老比例: <b style="color:#0369a1">${this.mockData.sales.profiles.newRatio} / ${this.mockData.sales.profiles.oldRatio}</b></div>
            <div style="margin-top:5px;">L3/L4 占比: <b style="color:#0369a1">${this.mockData.sales.profiles.l3l4Ratio}</b></div>
        `;
        document.getElementById('hot-products-list').innerHTML = this.mockData.sales.hotProducts.map((p, i) => `
            <div style="padding:4px 0; border-bottom:1px dashed #eee;">TOP ${i+1}: ${p}</div>
        `).join('');
        document.getElementById('trade-health-status').innerText = this.mockData.sales.health;
        
        const lastUpdate = document.getElementById('dashboard-last-update');
        if (lastUpdate) lastUpdate.innerText = '最后同步: ' + new Date().toLocaleString() + ' (Accio Work)';
    }
};

// 挂载到全局
window.Dashboard = Dashboard;
export { Dashboard };
